import { render, staticRenderFns } from "./NextoreConfig.vue?vue&type=template&id=6c8de7ba"
import script from "./NextoreConfig.vue?vue&type=script&lang=js"
export * from "./NextoreConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports